export default "__VITE_ASSET__CEVNe4fa__"